import { DEFAULT_TOTAL_RECORDS } from "utils/constants";

const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");

const zone_id = Number(localStorage.getItem("zone_id"));

export const fetchDoctorScheduleRouters = (
  page_no,
  filter,
  limit = DEFAULT_TOTAL_RECORDS,
) => {
  return axiosInstance.get(EndPoints.DOCTOR_SCHEDULE_ROUTER.LIST, {
    params: {
      limit,
      page_no,
      zone_id,
      ...filter,
    },
  });
};

export const fetchDoctorScheduleDropdown = (payload) => {
  return axiosInstance.get(EndPoints.DOCTOR_SCHEDULE_ROUTER.DROPDOWN, payload);
};

export const createDoctorScheduleRouter = (payload) => {
  return axiosInstance.post(EndPoints.DOCTOR_SCHEDULE_ROUTER.CREATE, payload);
};

export const updateDoctorScheduleRouter = (payload) => {
  return axiosInstance.put(EndPoints.DOCTOR_SCHEDULE_ROUTER.UPDATE, payload);
};

export const deleteDoctorScheduleRouter = (payload) => {
  const url = EndPoints.DOCTOR_SCHEDULE_ROUTER.DELETE + `/${payload}`;
  return axiosInstance.delete(url);
};

export const downloadDoctorScheduleCSV = () => {
  return axiosInstance.put(
    EndPoints.DOCTOR_SCHEDULE_ROUTER.DOWNLOAD_CSV,
    {},
    {
      responseType: "blob",
    },
  );
};
